/**
 * Reproduce un sonido corto (click de botón, etc.).
 * Ignora errores de autoplay / URL vacía.
 */
export function playEscapeRoomSound(url, { volume = 0.85 } = {}) {
	const src = String(url || "").trim();
	if (!src || typeof Audio === "undefined") return;
	try {
		const audio = new Audio(src);
		const v = Number(volume);
		audio.volume = Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0.85;
		const p = audio.play();
		if (p && typeof p.catch === "function") p.catch(() => {});
	} catch {
		/* ignore */
	}
}
